import {Button} from 'alm-react-components';
import {useNavigate} from 'react-router-dom';
import CarouselSection from '../../common/CarouselSection';
import {useTranslation} from 'react-i18next';
import {useContext, useEffect, useState} from 'react';
import {AppContext} from '../../../context/AppProvider';
import { APPROUTES, constants, podCastTags } from '../../../assets/constants/constants';
import { LibraryFilteration } from '../../../lib/utils';
type PodcastSectionType = {
  podcast?: any;
  addBookMark: any;
  deleteBookMark: any;
  catalogId: any;
};
const PodcastSection = ({podcast, addBookMark, deleteBookMark, catalogId}: PodcastSectionType) => {
  const {state} = useContext(AppContext);
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [filteredVideos,setFilteredVideos]=useState<any>(); 

  const postData: [] =
    podcast === APPROUTES.isHome ? state?.libraryData?.Podcast : podcast;
  useEffect(()=>{
    const data =  LibraryFilteration(postData,postData,constants.NEW_PODCASTS,podCastTags.innerSTancePodcasts,podCastTags.specialPodcasts,podCastTags.straightLinePodcasts)
   const sorterdData= data?.sort((a:any, b:any) =>b?.attributes?.localizedMetadata[0]?.name.localeCompare(a?.attributes?.localizedMetadata[0]?.name, 'es', {sensitivity: 'base'}))
   setFilteredVideos(sorterdData);
    },[postData])


  if (!filteredVideos || filteredVideos.length === 0) {
    return null;
  }
  return (
    <div className="mt-14 mb-14 xl:px-32 lg:px-8 md:px-8 px-5">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <h2 className="text-3xl lg:text-3xl xl:text-4xl font-barlowLight pl-2 max-md:mb-4">
          <span dangerouslySetInnerHTML={{ __html: (t('Program.podcast')) }} />
        </h2>
        {!state?.keyword&&(
          <Button
          variant="outline"
          onClick={() => navigate(`/podcasts/${catalogId?.id}?${podcast === APPROUTES.isHome ? "isHome=true" : ""}`)}
          className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard border-0"
        >
          <span dangerouslySetInnerHTML={{ __html: (t('Common.seeAll')) }} />
        </Button>)}
      </div>
      <CarouselSection
        data={filteredVideos}
        addBookMark={addBookMark}
        deleteBookMark={deleteBookMark}
        type={constants.PODCAST}
        id={catalogId?.id}
        from={podcast === APPROUTES.isHome ? APPROUTES.home : APPROUTES.library}
      />
    </div>
  );
};

export default PodcastSection;
